<div  [style.background-color]='getColor()'  class="modal-header">
    <h4 style="color: white;" class="modal-title pull-left">Language Variations</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeUpdateModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div> 

  <div class="modal-body">
      <div class="card-body"> 
      
        <button (click)="createLanguageVariationForOption();"
        style="width: auto;float: right;" class="btn btn-info">Create New Variation</button>
       <br>
       <br>
        <table
        class="table mat-elevation-z6 table-striped table-bordered table-sm row-border hover">
        <thead class="tableheader" >
          <tr>
            <th>Language</th>
            <th>Option Number</th>
            <th>Option</th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let langResOptn of botLangResOptions">
            <td class="td-height">{{langResOptn.fkBotLanguage}}</td>
            <td class="td-height">{{langResOptn.langResOptionNumber}}</td>
            <td class="td-height">
                {{langResOptn.langResOption}}
                <a style="cursor:pointer; margin-left: 2%;"
                (click)="edit(langResOptn);">
                    <img src="/assets/images/icons/edit.svg" width="20" height="20" alt="" loading="lazy">
               </a>
            </td>
            

            

          </tr>
        </tbody>
      </table>

</div>
</div>

